export const appendIfDefined = ({ key, value, formData }) => {
  if (value !== undefined && value !== null) {
    formData.append(key, value)
  }
}
